import { createApp } from 'vue'
import App from './App.vue'
import i18n from './locales'
import router from './router'
import pinia from './stores'

import '@unocss/reset/tailwind.css'
import '@/assets/styles/main.less'
import 'virtual:uno.css'

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)

app.mount('#app')
